import { StoreReaderConfig } from '@apollo/client/cache/inmemory/readFromStore'
import googleAnalyticsLinker from '../../../../analytics/google-analytics-linker'
import { IOption, OptionList } from '../types'
import { getListResults, ListResults } from './ListResults'
import { getSearchResults, SearchResults } from './SearchResults'

type SearchControllerCallbacks = {
  onNoResults?: (searchInput: string) => void
}

export class SearchController {
  listResults: ListResults
  searchResults: SearchResults
  endpointApp: string
  brandCode: string
  onNoResults?: (searchInput: string) => void

  constructor(
    endpointApp: string,
    brandCode: string,
    preselect: { industry: false | string; profession: false | IOption }, 
    callbacks: SearchControllerCallbacks
  ) {
    Object.assign(this, callbacks)

    this.listResults = getListResults(brandCode, preselect)
    this.searchResults = getSearchResults(brandCode)
    this.endpointApp = endpointApp
    this.brandCode = brandCode
  }

  loadOptions: (input: string) => Promise<OptionList> = async input => {
    // console.log('[Search Controller] loadOptions ', input)

    if (isMinLength(input)) {
      return this.search(input)
    } else {
      return this.listResults.fetch()
    }
  }

  async search(input: string): Promise<OptionList> {
    const results = await this.searchResults.fetch(input)
    const hasResults = results.length > 0
    if (!hasResults && this.onNoResults) {
      this.onNoResults(input)
    }
    return results
  }

  primeCache() {
    // console.log('[Search Controller] prime cache')
    this.listResults.primeCache()
  }

  startApplication = async (webBusClassId: string | number, forceRoute: boolean = false)  => {
    try {

      const getUrl = async () => {
        const urlSegments = [this.endpointApp, '?', `BusClassId=${webBusClassId}`]

        if (forceRoute) {
          urlSegments.push("&forceroute=true")
        }

        try {
          const linker = await googleAnalyticsLinker() 
          const urlWithLinker = [...urlSegments, '&', linker]
          return urlWithLinker.join('')
        } catch (ex) {
          console.warn(`[Google Analytics Linker] `, ex)
          return urlSegments.join('')           
        }
      }

      const url = await getUrl()
      
      console.log('App start: ', url)

      // fire the cannons
      window.location.href = url
    } catch {
      console.error('[App Start] failed to start app for business class ', webBusClassId)
    }
  }
}

export function isMinLength(input: string): boolean {
  return input.length >= 1
}
